module.exports = __webpack_public_path__ + "assets/media/website_preview.f91140d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ChatPreview/website_preview.svg
// module id = 2591
// module chunks = 0